// CreateCampaign.jsx - Every "+ New campaign" entry point in the studio
// routes through this component, which forwards to the wizard. The legacy
// PublicGameCreator chooser is no longer used as a creation surface; this
// route exists purely to preserve the /studio/new URL and pass query params
// (gameType, leadId, companyName) through to the wizard.
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

function NewCampaign() {
  const location = useLocation();
  // Preserve any query params (e.g. ?gameType=runner from game-type tiles
  // or ?leadId=... from the leads page) so the wizard can read them.
  return <Navigate to={`/wizard/new${location.search || ''}`} replace />;
}

export default NewCampaign;
